import { graphql } from '@eluve/graphql.tada';

export const chatSettingsFragment = graphql(`
  fragment ChatSettingsConversationStarters on TenantUserChatSettings @_unmask {
    __typename
    tenantId
    userId
    conversationStarters
  }
`);

export const getChatConversationStartersQuery = graphql(
  `
    query getChatSettingsForConversationStarters(
      $tenantId: uuid!
      $userId: uuid!
    ) {
      tenantUserChatSettingsByPk(tenantId: $tenantId, userId: $userId) {
        ...ChatSettingsConversationStarters
      }
    }
  `,
  [chatSettingsFragment],
);
